// extracted by mini-css-extract-plugin
module.exports = {"inputForm":"styles_inputForm__P6HWE"};